import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Form,
  InputGroup,
  FormControl,
  Image,
} from "react-bootstrap";
import "../assets/css/Contact/contact.css";
import { BsThreeDotsVertical, BsSearch } from "react-icons/bs";
import ContactDetails from "components/Contact/ContactDetails";
import DownArrow from "assets/img/icons/DownArrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { ContactsAction, searchContact } from "../Redux/Contacts/action";
import { store } from "../Redux/store";
import { checkTokenExpiration } from "../components/functions/tokenUtils";
import "../assets/css/Loaders/Inbound.css";
import { lineSpinner } from "ldrs";

export default function Contact() {
  lineSpinner.register();
  const dispatch = useDispatch();
  const abortControllerRef = useRef(null);
  const user = useSelector((state) => state.authReducer.data);
  const Contacts = useSelector((state) => state.contactsReducer?.contactsData);
  const contactError = useSelector(
    (state) => state.contactsReducer?.contactsDataError,
  );
  const [selectedRowColor, setSelectedRowColor] = useState("");
  const [contactId, setContactId] = useState(null);
  const tokenTime = store.getState().authReducer?.tokens?.access?.expires;
  const [limit, setLimit] = useState(20);
  let data = useSelector((state) => state.inboundReducer.MessageDetails);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState();
  const [spinner, setSpinner] = useState(false);
  const [scrollContactsSpinner, setScrollContactsSpinner] = useState(false);

  useEffect(() => {
    checkTokenExpiration(tokenTime);
  }, []);
  const handleRowClick = (id) => {
    setSelectedRowColor(id);
    setContactId(id);
  };

  const contactsData = async (params) => {
    await ContactsAction(dispatch, user?.accountID, params);
    setLoader(false);
  };

  useEffect(() => {
    if (!search) {
      contactsData({ limit });
      setLoader(true);
    }
  }, [user?.accountID, search]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Contacts?.results?.length !== Contacts?.totalResults) {
          let res = await contactsData({ limit });
          if (res) {
            setScrollContactsSpinner(false);
          }
        } else {
          setScrollContactsSpinner(false);
        }
      } catch (error) {
        console.error("Failed to fetch contacts data:", error);
        setScrollContactsSpinner(false);
      }
    };

    fetchData();
  }, [limit]);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    if (bottom) {
      setScrollContactsSpinner(true);
      setLimit(limit + 20);
    }
  };
  const handleClickSearch = async (search) => {
    if (search) {
      setSpinner(true);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      let res = await searchContact(
        dispatch,
        search,
        user?.accountID,
        abortControllerRef.current.signal,
      );
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (res) {
        setSpinner(false);
      }
    }
  };

  useEffect(() => {
    setSelectedRowColor("")
    setContactId(null)
    handleClickSearch(search);
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [search]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <Row className="m-2 p-0">
      <Col md={4} className="custom-Column-inbound-1  mt-3 m-0 pr-0">
        {/* Main section start */}
        <Row className="w-100">
          <Col className="d-flex flex-column justify-content-start" md={8}>
            <h4 className="main-h4-tag-large">Contacts</h4>
          </Col>
          <Col className="custom-icon-style d-flex justify-content-end">
            <div>
              <BsThreeDotsVertical size={25} />
            </div>
          </Col>
        </Row>
        {/* Main section end */}

        {/* Section Section Start */}
        <Row className="mt-4 d-flex justify-content-center w-100">
          <Col md={6} className="d-flex">
            <p className="contact-p-tag-large mr-2">All</p>
            <p className="contact-p-tag-large ml-2">Call</p>
          </Col>
          <Col className="d-flex justify-content-end ">
            <p className="contact-p-tag-large ">Options</p>
            <p>
              <img
                src={DownArrow}
                alt="downArrow"
                width={13}
                className="ml-1 p-0"
              />
            </p>
          </Col>
        </Row>
        {/* Section Section end */}

        {/*  search bar section  start */}
        <Row className="mt-1 w-100">
          <Col  >
            <Form >
              <Form.Group className="mb-3" controlId="formPlaintextEmail">
                <InputGroup className="rounded-pill cutom-searchbar">
                  <InputGroup.Text className="custom-border-inbound-icons">
                    <BsSearch />
                  </InputGroup.Text>
                  <FormControl
                    type="search"
                    name="search"
                    placeholder="Search"
                    className="custom-border p-2"
                    onKeyDown={handleKeyDown}
                    style={{ border: "none" }}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        {/* search bar section end */}

        {/* Contacts Detail section start */}
        {loader ? (
          <div className="loader-inbound">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="circle-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
              <div className="circle-3"></div>
              <div className="line-5"></div>
              <div className="line-6"></div>
              <div className="circle-4"></div>
              <div className="line-7"></div>
              <div className="line-8"></div>
              <div className="circle-5"></div>
              <div className="line-9"></div>
              <div className="line-10"></div>
              <div className="circle-6"></div>
              <div className="line-11"></div>
              <div className="line-12"></div>
              <div className="circle-7"></div>
              <div className="line-13"></div>
              <div className="line-14"></div>
              <div className="circle-8"></div>
              <div className="line-15"></div>
              <div className="line-16"></div>
              <div className="circle-9"></div>
              <div className="line-17"></div>
              <div className="line-18"></div>
              <div className="circle-10"></div>
              <div className="line-19"></div>
              <div className="line-20"></div>
            </div>
          </div>
        ) : (
          <div
            className="custom-contact-scrollable-div p-1 m-0"
            onScroll={handleScroll}
          >
            {spinner ? (
              <div className="text-center w-75 ml-4 mt-1">
                <l-line-spinner
                  size="25"
                  stroke="3"
                  speed="1"
                  color="black"
                ></l-line-spinner>
              </div>
            ) : Contacts ? (
              <>
                {Contacts?.results?.map((data, index) => {
                  const getInitials = (nameData) => {
                    if (nameData && nameData?.name) {
                      const nameParts = nameData?.name.split(" ");
                      const firstTwoWords = nameParts?.slice(0, 2);
                      return firstTwoWords
                        ?.map((part) => part[0])
                        .join("")
                        .toUpperCase();
                    } else if (
                      nameData &&
                      nameData?.firstName &&
                      nameData?.lastName
                    ) {
                      return `${nameData?.firstName[0]}${nameData?.lastName[0]}`.toUpperCase();
                    } else {
                      return "NA";
                    }
                  };
                  const initials = getInitials(data);
                  return (
                    <Row
                      key={index}
                      className={`mt-1 p-3 ml-1 custom-row d-flex align-items-center p-0  ${
                        selectedRowColor === data?.id
                          ? "selected-row-active"
                          : "NA"
                      }`}
                      onClick={() => handleRowClick(data?.id)}
                    >
                      <Col md={2} className="p-0">
                        {/* <strong className='custom-bg-messageSection'>{initials}</strong> */}
                        <Image
                          src={`https://ui-avatars.com/api/?name=${initials}&background=172e57&color=fff&size=35`}
                          roundedCircle
                          className="custom-avatar"
                        />
                      </Col>
                      <Col className="d-flex flex-column">
                        <strong>
                          {data?.name
                            ? data?.name?.toUpperCase()
                            : "Not Available"}
                        </strong>
                      </Col>
                    </Row>
                  );
                })}
                {scrollContactsSpinner ? (
                  <div className="text-center w-100 mt-1">
                    <l-line-spinner
                      size="25"
                      stroke="3"
                      speed="1"
                      color="black"
                    ></l-line-spinner>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : contactError ? (
              <p
                className="m-3 p-2 border w-75 rounded text-center"
                style={{ color: "red" }}
              >
                {contactError}
              </p>
            ) : (
              ""
            )}
          </div>
        )}
      </Col>
      {/* Contact Details section end */}

      {/* Message detail section starts */}
      <Col className="mt-5">
        <Row>
          <Col>
            <ContactDetails id={contactId} />
          </Col>
        </Row>
      </Col>
      {/* Message detail section end */}
    </Row>
  );
}
